import { EventEntity } from '../../PubSub';

export enum RowActions {
  FETCH_MORE_ROWS = 'FETCH_MORE_ROWS',
  COLLAPSE_ROW = 'COLLAPSE_ROW',
}

export type FetchMoreRowsEvent = EventEntity<
  RowActions.FETCH_MORE_ROWS,
  {
    rowId: string;
  }
>;

export type CollapseRowEvent = EventEntity<
  RowActions.COLLAPSE_ROW,
  {
    rowId: string;
  }
>;

export type RowEvents = FetchMoreRowsEvent | CollapseRowEvent;

export function isCollapseRowEvent(
  event: RowEvents
): event is CollapseRowEvent {
  return event.kind === RowActions.COLLAPSE_ROW;
}

export function isFetchMoreRows(event: RowEvents): event is FetchMoreRowsEvent {
  return event.kind === RowActions.FETCH_MORE_ROWS;
}
